const th = {
  "comingSoon": "เร็ว ๆ นี้",
  "soonSub": "การล่าโทรลล์ครั้งใหม่",
  "follow": "ติดตามข่าวสารจากเรา",
  "playNow": "เล่นเส้นทางฟยอร์ดตอนนี้",
  "prev": "เส้นทางก่อนหน้า",
  "next": "เส้นทางถัดไป",
  "of": "/",
  "readMore": "อ่านเกี่ยวกับเส้นทาง",
  "otherTrails": "เส้นทางใหม่กำลังจะมา",
  "partner": {
    "kicker": "สำหรับธุรกิจและเทศบาล",
    "badge": "สำหรับธุรกิจ",
    "title": "มาเป็นพันธมิตรกับ Trollfossjakten",
    "pitch": "โรงแรม คาเฟ่ ซาวน่า รีสอร์ตสกี และทั้งเทศบาล สามารถวางโทรลล์ของตัวเองบนแผนที่ได้ การล่าจะพาครอบครัวและนักท่องเที่ยวมาถึงหน้าประตูคุณ — ตลอดทั้งปี",
    "points": [
      "สถานที่ของคุณถูกปักหมุดบนแผนที่โทรลล์",
      "ลูกค้าสั่งล่วงหน้าและจ่ายผ่าน Vipps",
      "ราคาเปิดตัว: ลด 50% สำหรับ 50 รายแรก"
    ],
    "cta": "มาเป็นพันธมิตร",
    "cta2": "สำหรับธุรกิจ",
    "pin": "ธุรกิจของคุณที่นี่",
    "stamp": "ลด 50%"
  },
  "names": {
    "partner": "เป็นพันธมิตร",
    "fjord": "เส้นทางฟยอร์ด",
    "stairs": "บันไดพระอาทิตย์เที่ยงคืน",
    "farm": "โทรลล์แห่ง Ågård",
    "forest": "เส้นทางป่า",
    "sea": "เส้นทางโทรลล์ทะเล"
  },
  "slides": {
    "stairs": {
      "kicker": "Spansdalen · Lavangen",
      "title": "บันไดพระอาทิตย์เที่ยงคืน: โทรลล์ 20 ตัวบนบันได 2117 ขั้น",
      "pitch": "บันไดไม้ที่ไต่ขึ้นตรงไปตามไหล่เขา Spanstind / Ruŋgugáisá — ปีนสูง 380 เมตร พร้อมวิวหุบเขา Spansdalen และฟยอร์ด Lavangen โทรลล์ยี่สิบตัวรออยู่บนขั้นบันได บนจุดชมวิว และข้างน้ำตก Henrikkafossen",
      "stats": [
        [
          "20",
          "โทรลล์"
        ],
        [
          "2117",
          "ขั้นบันได"
        ],
        [
          "380",
          "เมตรที่ปีนขึ้น"
        ]
      ],
      "note": "สวยที่สุดใต้พระอาทิตย์เที่ยงคืนในเดือนมิถุนายนและกรกฎาคม"
    },
    "farm": {
      "kicker": "Lavangen · Troms",
      "title": "โทรลล์แห่ง Ågård: โทรลล์ 30 ตัวอีกฝั่งของหุบเขา",
      "pitch": "ถนนช่วงใหม่อีกฝั่งของหุบเขา ผ่านบ้านไร่สีแดง ราวตากหญ้าแห้ง ทุ่งเลี้ยงแกะ และชายฝั่ง โทรลล์ชาวไร่ใส่หมวกไหมพรมแอบอยู่หลังรั้วและถังนม",
      "stats": [
        [
          "30",
          "โทรลล์"
        ],
        [
          "1",
          "ถนนสายใหม่"
        ],
        [
          "4",
          "ฤดูกาล"
        ]
      ],
      "note": "ถนนสายใหม่ — และโทรลล์ชุดใหม่ทั้งหมด"
    },
    "forest": {
      "kicker": "Lavangen · Gratangen",
      "title": "เส้นทางป่า: โทรลล์ 25 ตัวท่ามกลางต้นเบิร์ชและต้นสน",
      "pitch": "ทางเดินแคบ ๆ ผ่านป่าเบิร์ชและป่าสนที่ปกคลุมด้วยมอส ผ่านบึงที่เต็มไปด้วยหญ้าฝ้าย ลำธารไหลริน และสะพานไม้เล็ก ๆ โทรลล์มอสสวมหมวกเห็ดแอบมองออกมาจากหลังลำต้นและก้อนหิน",
      "stats": [
        [
          "25",
          "โทรลล์"
        ],
        [
          "1",
          "เส้นทางป่า"
        ],
        [
          "4",
          "ฤดูกาล"
        ]
      ],
      "note": "อย่าลืมพกกล้อง — และช็อกโกแลต"
    },
    "sea": {
      "kicker": "Gratangen · Lavangen · Sjøvegan",
      "title": "เส้นทางโทรลล์ทะเล: จับคราเคนและเต่ายักษ์",
      "pitch": "เส้นทางล่องเรือในฟยอร์ดจาก Gratangen ผ่าน Lavangen ไปยัง Sjøvegan ใต้ผิวน้ำมีโทรลล์ทะเลและยักษ์ยาว 45 เมตรสองตัวรออยู่ — คราเคน และเต่ายักษ์โบราณที่แบกเกาะทั้งเกาะไว้บนหลัง",
      "stats": [
        [
          "15",
          "โทรลล์ทะเล"
        ],
        [
          "45 ม.",
          "ยักษ์ใหญ่"
        ],
        [
          "3",
          "ท่าเรือ"
        ]
      ],
      "note": "แพ็กเกจล่องเรือพิเศษสำหรับแขกที่ชำระเงิน"
    }
  }
};

export default th;
